export type UploadDropzoneType = 'image' | 'video' | 'csv';

export const ALLOWED_EXTENSIONS = {
  image: ['.jpeg', '.jpg', '.png'],
  video: ['.mp4', '.mov', '.webm', '.mkv'],
  csv: ['.csv'],
} as const;

export const isValidExtension = (fileName: string, type: UploadDropzoneType) =>
  ALLOWED_EXTENSIONS[type].some((ext) => fileName.endsWith(ext));

export const TYPE_PLACEHOLDER_MAP = {
  image: 'an image',
  video: 'a video',
  csv: 'a CSV file',
} as const;
